import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ActivationUsersResponseSchema } from "../response/PropertyActivationResponse";

const API_VERSION = "v4";

/**
 * Users assigned to a property, for the "un-assign users" step of the deactivate
 * dialog. Protected platform accounts are included but flagged `is_protected`.
 */
export const usePropertyActivationUsers = (propertyId: string | null | undefined, enabled = true) => {
    return useQuery({
        queryKey: ['property-activation-users', propertyId],
        enabled: enabled && !!propertyId,
        queryFn: async () => {
            const response = await privateApi.get(`/${API_VERSION}/property/${propertyId}/activation/users`);
            return ActivationUsersResponseSchema.parse(response.data);
        },
        refetchOnWindowFocus: false,
    });
};
